// api/wechat.js
import axios from '@/api'

/**
 * 生成微信授权URL
 */
export const generateAuthUrl = (redirectUri, scope) => {
  return axios.get('/wx/auth/url', {
    params: { redirectUri, scope }
  }).then(res => {
    return res.data
  })
}

/**
 * 使用code登录
 */
export const wxLogin = (code) => {
  return axios.get('/wx/auth/login', {
    params: { code }
  }).then(res => res.data)
}

/**
 * 校验文本是否符合规则
 */
export const checkText = (data) => {
  return axios.post('/wx/v1/check/text', data).then(res => res.data)
}
